/**
 * CommonStyle.ts
 */
export class CommonStyle {
}
CommonStyle.MODULE = "Game";
CommonStyle.BACKGROUND = "Background";
CommonStyle.BACKGROUND_LANDSCAPE = "BackgroundLandscape";
CommonStyle.BACKGROUND_PORTRAIT = "BackgroundPortrait";
CommonStyle.MESSAGE_DIALOG_0 = "MessageDialog0";
CommonStyle.MESSAGE_DIALOG_1 = "MessageDialog1";
CommonStyle.DIALOG_BUTTON_0 = "DialogButton0";
CommonStyle.DIALOG_BUTTON_1 = "DialogButton1";
CommonStyle.DIALOG_BUTTON_2 = "DialogButton2";
CommonStyle.DEMO_PLAY_BACKGROUND = "DemoPlayBackground";
CommonStyle.STAKE_SELECTOR_TOGGLE_BUTTON = "StakeSelectorToggleButton";
CommonStyle.STAKE_SELECTOR_VALUE_BUTTON = "StakeSelectorValueButton";
CommonStyle.STAKE_SELECTOR_TOP = "StakeSelectorTop";
CommonStyle.STAKE_SELECTOR_BOTTOM = "StakeSelectorBottom";
CommonStyle.STAKE_SELECTOR_BACKGROUND = "StakeSelectorBackground";
CommonStyle.STAKE_SELECTOR_INCREMENT_BUTTON = "StakeSelectorIncrementButton";
CommonStyle.STAKE_SELECTOR_DECREMENT_BUTTON = "StakeSelectorDecrementButton";
CommonStyle.OPTIONS_TOGGLE_BUTTON = "OptionsToggleButton";
CommonStyle.OPTIONS_MENU = "OptionsMenu";
CommonStyle.OPTIONS_MENU_AUDIO_BUTTON = "OptionsMenuAudioButton";
CommonStyle.OPTIONS_MENU_DEPOSIT_BUTTON = "OptionsMenuDepositButton";
CommonStyle.OPTIONS_MENU_HELP_BUTTON = "OptionsMenuHelpButton";
CommonStyle.OPTIONS_MENU_HOME_BUTTON = "OptionsMenuHomeButton";
CommonStyle.OPTIONS_MENU_PAY_TABLE_BUTTON = "OptionsMenuPayTableButton";
CommonStyle.OPTIONS_MENU_RESPONSIBLE_GAMING_BUTTON = "OptionsMenuResponsibleGamingButton";
CommonStyle.OPTIONS_MENU_GAME_HISTORY_BUTTON = "OptionsMenuGameHistoryButton";
CommonStyle.HELP_PAGING = "Help";
CommonStyle.HELP_NEXT_BUTTON = "HelpNextButton";
CommonStyle.HELP_PREVIOUS_BUTTON = "HelpPreviousButton";
CommonStyle.HELP_CLOSE_BUTTON = "HelpCloseButton";
CommonStyle.HELP_ACCESSIBILITY_BUTTON = "HelpAccessibilityButton";
CommonStyle.RESPONSIBLE_GAMING_OPTION_BUTTON = "ResponsibleGamingOptionButton";
CommonStyle.RESPONSIBLE_GAMING = "ResponsibleGaming";
CommonStyle.RESPONSIBLE_GAMING_BACKGROUND = "ResponsibleGamingBackground";
CommonStyle.RESPONSIBLE_GAMING_LOGO = "ResponsibleGamingLogo";
CommonStyle.RESPONSIBLE_GAMING_ICON = "ResponsibleGamingIcon";
CommonStyle.CHECK_BOX = "CheckBox";
CommonStyle.DGH_OPTION_BUTTON = "DGHOptionButton";
/**
 * CommonSnapshot.ts
 */
export class CommonSnapshot {
}
CommonSnapshot.RESPONSIBLE_GAMING = "CommonSnapshot.RESPONSIBLE_GAMING";
/**
 * InstructionsSnapshot.ts
 */
export class InstructionsSnapshot {
}
InstructionsSnapshot.REELS = "InstructionsSnapshot.REELS";
InstructionsSnapshot.REELS_WITH_JOKERS = "InstructionsSnapshot.REELS_WITH_JOKERS";
InstructionsSnapshot.TICKET = "InstructionsSnapshot.TICKET";
InstructionsSnapshot.TICKET_WITH_JOKERS = "InstructionsSnapshot.TICKET_WITH_JOKERS";
InstructionsSnapshot.COLLECT_BUTTON = "InstructionsSnapshot.COLLECT_BUTTON";
InstructionsSnapshot.PURCHASE_SPIN_BUTTON = "InstructionsSnapshot.PURCHASE_SPIN_BUTTON";
InstructionsSnapshot.PAY_TABLE_IN_PROGRESS = "InstructionsSnapshot.PAY_TABLE_IN_PROGRESS";
/**
 * LoaderStyle.ts
 */
export class LoaderStyle {
}
LoaderStyle.MODULE = "Loader";
LoaderStyle.BACKGROUND = "Background";
LoaderStyle.BACKGROUND_PORTRAIT = "BackgroundPortrait";
LoaderStyle.BACKGROUND_ONLY = "BackgroundOnly";
LoaderStyle.PROGRESS_BAR = "ProgressBar";
/* LoaderDialog.ts */
LoaderStyle.LOGO = "Logo";
LoaderStyle.GUIDE_IMAGE = "Image";
LoaderStyle.CONTINUE_BUTTON = "PlayButton";
LoaderStyle.PROGRESS_BAR_BACKGROUND = "ProgressBarBackground";
LoaderStyle.MESSAGE_BOX = "MessageDialog0";
LoaderStyle.PAGE_BUTTON = "";
LoaderStyle.PREVIOUS_BUTTON = "PreviousButton";
LoaderStyle.NEXT_BUTTON = "NextButton";
/**
 * OrientationStyle.ts
 */
export class OrientationStyle {
}
OrientationStyle.MODULE = "Orientation";
OrientationStyle.BACKGROUND = "Background";
/**
 * PreloaderStyle.ts
 */
export class PreloaderStyle {
}
PreloaderStyle.PRELOADER = "Preloader";
/**
 * PreloaderStyle.ts
 */
export class FullScreenStyle {
}
FullScreenStyle.FULL_SCREEN = "FullScreen";
//# sourceMappingURL=CommonStyle.js.map